/**
 * Badge Categories API Endpoints
 * API service for badge category management + badge rarity moderation (admin)
 */

import { ApiService } from '../apiService'
import type {
  BadgeCategoryDto,
  ListBadgeCategoriesParams,
  CreateBadgeCategoryRequest,
  UpdateBadgeCategoryRequest,
  CollectionBadgeModerationDto,
  ListCollectionBadgesParams,
  SetBadgeRarityRequest,
} from '../types/badgeCategory'

export const badgeCategoriesApi = {
  /** Get all badge categories */
  getCategories: (params?: ListBadgeCategoriesParams) =>
    ApiService.get<BadgeCategoryDto[]>('/admin/badge-categories', params),

  /** Get a single badge category */
  getCategory: (id: number) =>
    ApiService.get<BadgeCategoryDto>(`/admin/badge-categories/${id}`),

  /** Create a new badge category */
  createCategory: (data: CreateBadgeCategoryRequest) =>
    ApiService.post<BadgeCategoryDto>('/admin/badge-categories', data),

  /** Update an existing badge category */
  updateCategory: (id: number, data: UpdateBadgeCategoryRequest) =>
    ApiService.put<BadgeCategoryDto>(`/admin/badge-categories/${id}`, data),

  /** Delete a badge category */
  deleteCategory: (id: number) =>
    ApiService.delete<void>(`/admin/badge-categories/${id}`),
}

export const badgeModerationApi = {
  /** Get collection badges for rarity moderation */
  getCollectionBadges: (params?: ListCollectionBadgesParams) =>
    ApiService.get<CollectionBadgeModerationDto[]>(
      '/admin/badges/collection-badges',
      params
    ),

  /** Set a collection badge's rarity */
  setRarity: (badgeId: string, data: SetBadgeRarityRequest) =>
    ApiService.put<CollectionBadgeModerationDto>(
      `/admin/badges/collection-badges/${badgeId}/rarity`,
      data
    ),
}
